import tinymce from 'tinymce';
import camelCase from 'lodash/camelCase';

const ATTRIBUTE_NAME = 'data-custom-tooltip';
const FORMAT_NAME = 'customTooltip';

const toggleState = (editor, toggler) => {
  editor.on('NodeChange', toggler);
  return () => editor.off('NodeChange', toggler);
};

const isTooltipNode = (node) => node?.getAttribute(ATTRIBUTE_NAME);

const toggleActiveState = (editor, api) => {
  toggleState(editor, () => {
    const node = editor?.selection.getNode();
    api.setActive(!editor.mode.isReadOnly() && isTooltipNode(node));
  });
};

const registerFormatter = (editor) => {
  editor.formatter.register(FORMAT_NAME, {
    inline: 'span',
    // https://www.tiny.cloud/docs/configure/content-formatting/#variablesubstitution
    attributes: { [ATTRIBUTE_NAME]: 'true', title: '%title' },
    styles: { backgroundColor: '%backgroundColor' },
    remove_similar: true,
  });
};

const parseStyles = (style = '') =>
  style.split(';').reduce((acc, rule) => {
    const [key, value] = rule.split(':');

    if (!key || !value) return acc;

    acc[camelCase(key)] = value.trim();

    return acc;
  }, {});

tinymce.PluginManager.add('tooltip', function (editor) {
  const openDialog = () => {
    const selectedNode = tinymce.activeEditor.selection.getNode();

    const tooltip = selectedNode.getAttribute('title') || '';
    const styleAttr = selectedNode.getAttribute('style') || '';
    const { backgroundColor } = parseStyles(styleAttr);

    return editor.windowManager.open({
      title: 'tooltip plugin',
      body: {
        type: 'panel',
        items: [
          { type: 'input', name: 'title', label: 'Text for tooltip' },
          { type: 'colorinput', name: 'backgroundColor', label: 'Text background' },
        ],
      },
      buttons: [
        { type: 'cancel', text: 'Close' },
        { type: 'custom', text: 'Remove', name: 'remove' },
        { type: 'submit', text: 'Save', primary: true },
      ],
      initialData: { title: tooltip, backgroundColor: backgroundColor || '' },

      onAction: (api, details) => {
        if (details.name === 'remove') {
          editor.undoManager.transact(() => {
            editor.focus();
            editor.formatter.remove(FORMAT_NAME, { title: null, backgroundColor: null }, null, true);
            editor.nodeChanged();
          });
        }

        api.close();
      },

      onSubmit(api) {
        const data = api.getData();

        editor.undoManager.transact(() => {
          editor.focus();
          editor.formatter.apply(FORMAT_NAME, data);
          editor.nodeChanged();
        });

        api.close();
      },
    });
  };

  // Add a button that opens a window
  editor.ui.registry.addToggleButton('tooltip', {
    text: 'Tooltip',
    tooltip: 'Add/change/remove tooltip',
    onAction() {
      openDialog();
    },
    onSetup: (api) => {
      registerFormatter(editor);
      toggleActiveState(editor, api);
    },
  });

  return {
    getMetadata() {
      return {
        name: 'Tooltip plugin',
      };
    },
  };
});
